// Returns true if the cell (x, y) is already covered by an existing merge in the given merged array
export const isCellUnderMerge = (merged, x, y) =>
  merged.some((m) => {
    const mEndX = m.cell.x + (m.dir === "down" ? m.length : 0);
    const mEndY = m.cell.y + (m.dir === "right" ? m.length : 0);
    return x >= m.cell.x && x <= mEndX && y >= m.cell.y && y <= mEndY;
  });
